import CatalogItemSkeleton from "./CatalogItemSkeleton";

export default CatalogItemSkeleton;